// UI-free reasoning-effort definitions, kept separate from ReasoningEffortPicker
// so non-UI consumers (storage hooks, submit utilities) can validate/label efforts
// without pulling in @primer/react or the picker's CSS module.

export type ReasoningEffort = 'none' | 'low' | 'medium' | 'high' | 'xhigh' | 'max'

export interface ReasoningEffortOption {
  value: ReasoningEffort
  label: string
  description: string
}

export const REASONING_EFFORT_OPTIONS: ReasoningEffortOption[] = [
  {value: 'none', label: 'None', description: 'No reasoning for the simplest tasks'},
  {value: 'low', label: 'Low', description: 'Faster responses for simpler tasks'},
  {value: 'medium', label: 'Medium', description: 'Balanced reasoning for most tasks'},
  {value: 'high', label: 'High', description: 'More reasoning for complex tasks'},
  {value: 'xhigh', label: 'X-High', description: 'Extended reasoning for harder tasks'},
  {value: 'max', label: 'Max', description: 'Maximum reasoning for the hardest tasks'},
]

export const REASONING_EFFORT_VALUES: ReasoningEffort[] = REASONING_EFFORT_OPTIONS.map(option => option.value)

export function isReasoningEffort(value: unknown): value is ReasoningEffort {
  return typeof value === 'string' && (REASONING_EFFORT_VALUES as string[]).includes(value)
}

// No selected effort renders as "Default": the backend picks the model's own default
// effort, which is model-specific and not always medium.
export function getReasoningEffortLabel(value?: string): string {
  if (!value) return 'Default'
  return REASONING_EFFORT_OPTIONS.find(option => option.value === value)?.label ?? value
}
